import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button, FormControl, Grid, InputLabel, OutlinedInput, Paper, Typography, Zoom } from "@material-ui/core";
import { Link } from "react-router-dom";
import { trim } from "../../helpers";
import PairLogo from "../../components/PairLogo";
import { changeSearch } from "../../slices/StakeThunk";
import "./search.scss";
import { useWeb3Context } from "src/hooks/web3Context";
import { isPendingTxn, txnButtonText } from "src/slices/PendingTxnsSlice";
import { Skeleton } from "@material-ui/lab";
import { error } from "../../slices/MessagesSlice";
import { ethers } from "ethers";
import { chains } from "src/constants";

function Search() {
  const dispatch = useDispatch();
  const { provider, address, connected, connect, chainID } = useWeb3Context();

  const [pair, setPair] = useState("");
  const [token0, setToken0] = useState("");
  const [token1, setToken1] = useState("");
  const [zoomed, setZoomed] = useState(false);

  const onChangeStake = async value => {
    await dispatch(
      changeSearch({
        address,
        value: value.toString(),
        provider,
        networkID: chainID,
        callback: (token0, token1) => {
          setToken0(token0);
          setToken1(token1);
          setPair(value.toString());
        },
      }),
    );
  };

  let modalButton = [];

  modalButton.push(
    <Button variant="contained" color="primary" className="connect-button" onClick={connect} key={1}>
      Connect Wallet
    </Button>,
  );

  return (
    <div id="stake-view">
      <Zoom in={true} onEntered={() => setZoomed(true)}>
        <Paper className={`unicrypt-card`}>
          <Grid container direction="column" spacing={2}>
            <Grid item>
              <div className="card-header">
                <Typography variant="h5">{chains[chainID] && chains[chainID].dexLabel} Locker</Typography>
              </div>
              <div className={`stake-user-data`}>
                <div className="data-row">
                  <Typography variant="h6">
                    Use the locker to prove to investors you have locked liquidity. If you are not a token developer,
                    this section is almost definitely not for you.
                  </Typography>
                </div>
                <div className="data-row">
                  <Typography variant="h6">Our lockers offer</Typography>
                  <ul className="function-list">
                    <li>
                      <Typography variant="h6">Lock splitting</Typography>
                    </li>
                    <li>
                      <Typography variant="h6">Liquidity Migration</Typography>
                    </li>
                    <li>
                      <Typography variant="h6">Relocking</Typography>
                    </li>
                    <li>
                      <Typography variant="h6">Lock ownership transfer</Typography>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="staking-area">
                {!address ? (
                  <div className="stake-wallet-notification">
                    <div className="wallet-menu" id="wallet-menu">
                      {modalButton}
                    </div>
                    <Typography variant="h6">Connect your wallet to lock</Typography>
                  </div>
                ) : (
                  <>
                    <div className={`stake-user-data`}>
                      <Typography variant="h6">
                        
                        {`Enter the ${chains[chainID] && chains[chainID].dexLabel} pair address youd like to lock liquidity for`}
                      </Typography>
                    </div>
                    <Box className="stake-action-area">
                      <Box className="stake-action-row" display="flex" alignItems="center">
                        <FormControl className="unicrypt-input" variant="outlined" color="primary">
                          <OutlinedInput
                            type="text"
                            placeholder={`${chains[chainID] && chains[chainID].dexLabel} pair address...`}
                            className="stake-input"
                            onChange={e => onChangeStake(e.target.value)}
                          />
                        </FormControl>
                      </Box>
                      <div className={`stake-address-eg`}>
                        <Typography variant="body1" className={`stake-address-eg-typography`}>
                          e.g. 0xc736cA3d9b1E90Af4230BD8F9626528B3D4e0Ee0
                        </Typography>
                      </div>
                      {token0 !== "" && token1 !== "" ? (
                        <div className="data-row-pairbox">
                          <div style={{ display: "flex" }}>
                            <PairLogo />
                            <Typography variant="h5">{`${token0} / ${token1}`}</Typography>
                          </div>
                          <Button
                            className="stake-button"
                            variant="contained"
                            color="primary"
                            style={{ marginTop: "10px" }}
                          >
                            <Link to={`/new-lock/${pair}`} className="stake-button-link">
                              CONTIUE
                            </Link>
                          </Button>
                        </div>
                      ) : (
                        <></>
                      )}
                    </Box>
                  </>
                )}
              </div>
            </Grid>
          </Grid>
        </Paper>
      </Zoom>
    </div>
  );
}

export default Search;
